
import * as defaultImport from "@splunk/visualization-icons/placeholders";
export * from "@splunk/visualization-icons/placeholders";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
